import { Routes } from '@angular/router';
import { RoleEnum } from '@core/config/role.enum';
import { authGuardWithRedirectFn } from 'ok-angular-shared/auth';
import { CanActivateInstallationCompleteService } from './installation-complete/can-activate-installation-complete.service';

export const installationRoutes: Routes = [
  {
    path: 'installations',
    canActivate: [authGuardWithRedirectFn],
    loadComponent: () => import('./installation-overview/installation-overview.component').then(m => m.InstallationOverviewComponent),
    data: { roles: [RoleEnum.Subcontractor, RoleEnum.Tsc, RoleEnum.Emobility, RoleEnum.Ekc] },
    title: 'Installationer',
  },
  {
    path: 'installation/complete/:installationNumber',
    canActivate: [authGuardWithRedirectFn, CanActivateInstallationCompleteService],
    loadComponent: () => import('./installation-complete/installation-complete.component').then(m => m.InstallationCompleteComponent),
    data: { roles: [RoleEnum.Subcontractor, RoleEnum.Tsc, RoleEnum.Emobility] },
    title: 'Installer Ladeboks',
  },
  {
    path: 'installation/edit/:customerType/:id',
    canActivate: [authGuardWithRedirectFn],
    loadComponent: () => import('./installation-edit/installation-edit.component').then(m => m.InstallationEditComponent),
    data: { roles: [RoleEnum.Subcontractor, RoleEnum.Tsc, RoleEnum.Emobility] },
    title: 'Rediger Installation',
  },
  {
    path: 'installation/change-charging-station/:installationNumber',
    canActivate: [authGuardWithRedirectFn],
    loadComponent: () =>
      import('./installation-change-charging-station/installation-change-charging-station.component').then(
        m => m.InstallationChangeChargingStationComponent
      ),
    data: { roles: [RoleEnum.Subcontractor, RoleEnum.Tsc, RoleEnum.Emobility] },
    title: 'Skift Ladeboks',
  },
  {
    path: 'installation/relocate/:installationNumber',
    canActivate: [authGuardWithRedirectFn],
    loadComponent: () => import('./installation-relocate/installation-relocate.component').then(m => m.InstallationRelocateComponent),
    data: { roles: [RoleEnum.Subcontractor, RoleEnum.Tsc, RoleEnum.Emobility] },
    title: 'Installer Ladeboks',
  },
];
